'use strict';

var React = require('react');
var classNames = require('classnames');
var ObjectHelper = require('../../../common/ObjectHelper.js');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = function styles() {
  return {
    actionPadding: {
      padding: 6,
      marginLeft: 4
    }
  };
};

var CardHeaderActions = function CardHeaderActions(_ref) {
  var children = _ref.children,
      classes = _ref.classes;

  var addPaddingToChild = function addPaddingToChild(child, index) {
    if (React__default["default"].isValidElement(child)) {
      var className = classNames__default["default"](classes.actionPadding, child.props.className);
      var props = {
        key: index,
        className: className
      };
      return React__default["default"].cloneElement(child, props);
    }

    return null;
  };

  if (!ObjectHelper.isPresent(children)) {
    return null;
  } else if (Array.isArray(children)) {
    return children.map(function (child, index) {
      return addPaddingToChild(child, index);
    });
  } else {
    return addPaddingToChild(children, 0);
  }
};

var CardHeaderActions$1 = withStyles(styles)(CardHeaderActions);

module.exports = CardHeaderActions$1;
